document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var a = q.parentElement.querySelector('.faq-a');
      var s = q.querySelector('span');
      var open = a.style.display === 'block';
      document.querySelectorAll('.faq-a').forEach(function (el) { el.style.display = 'none'; });
      document.querySelectorAll('.faq-q span').forEach(function (sp) { sp.textContent = '+'; });
      if (!open) { a.style.display = 'block'; s.textContent = '\u2212'; }
    });
  });
});
